import { CampaignData, EnablementInfoPayloadV3 } from 'interface/WizardV3';

export const getSubmissionDate = ({
  smsCampaignData,
  enablementInfo,
}: {
  smsCampaignData: CampaignData;
  enablementInfo: EnablementInfoPayloadV3;
}) => {
  if (smsCampaignData?.submissionDateMs) {
    return new Date(smsCampaignData?.submissionDateMs);
  }
  if (enablementInfo?.updateDate) {
    return new Date(enablementInfo?.updateDate);
  }
  return new Date();
};
